import { provider } from '@/provider.js'
import { handleActionError } from '../../errors'
import { providerResponseHandler } from '@/stores/helpers'

export default {
  async reloadMetrics({ commit }) {
    try {
      commit('setMetricsLoading', true)
      const metricsResponse = await provider.getMetrics()
      const metrics = []
      if (metricsResponse && metricsResponse.currentUser && metricsResponse.currentUser.account && metricsResponse.currentUser.account.caseTypes) {
        for (const ct of metricsResponse.currentUser.account.caseTypes) {
          for (const metric of ct.metrics) {
            metrics.push(metric)
          }
        }
      }
      commit('updateMetrics', metrics)
      commit('setMetricsLoading', false)
    } catch (error) {
      handleActionError(error, commit)
    }
  },
  async updateMetric({commit}, metric) {
    try {
      const response = await provider.updateMetric(metric)
      providerResponseHandler(response, "Unexpected response updating metric.", () => {
        commit('setMetric', response.metric)
        commit("displayFlashMessage", { message: "Metric updated.", severity: "success" })
      })
    } catch (error) {
      handleActionError(error, commit)
    }
  },
  async deleteMetric({commit}, metric) {
    try {
      const response = await provider.deleteMetric(metric)
      providerResponseHandler(response, "Unexpected response deleting metric.", () => {
        commit('deleteMetric', metric)
      })
    } catch (error) {
      handleActionError(error, commit)
    }
  },
  async createMetric({commit}, metric) {
    try {
      let response = undefined
      switch (metric.type) {
        case 'Case Property':
          response = await provider.createCasePropertyMetric(metric)
          break;
        case 'State Transition':
          response = await provider.createStateTransitionMetric(metric)
          break;
        case 'Bucket':
          response = await provider.createBucketMetric(metric)
          break;
              
        default:
          throw new Error("Metric contains unrecognized type.")
      }
      providerResponseHandler(response, "Unexpected response creating metric.", () => {
        commit('addMetric', response.metric)
      })
    } catch (error) {
      handleActionError(error, commit)
    }
  }

}